import axios from 'axios'
import { PageDataResponse, DataArrayResponse,DataObjectResponse  ,PageResponse } from '../models/PageResponse'
import { Asset,DeleteData}  from '../models'
import { config } from '../config'
import { CookieHelper } from '../helpers'

const apiUrl = config.API_URL

export default class AssetService
{
    protected headers = {}
    protected token = ""

    constructor(token:string | null){
        if(token){
            this.token = token
            this.headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        }
    }
    
    async getAll(page: number,limit: number,key:string ){
        let options = {
                headers: this.headers,
                params: {
                    page: page,
                    limit: limit,
                    key: key
                }
            }
        
        const { data }  = await axios.get<PageDataResponse<Asset>>(`${apiUrl}/v1/assets/call`, options )
        
        return data;
    }

    async getById(id: number){
        let options = {
                headers:this.headers,
            }
        
        const { data }  = await axios.get<DataObjectResponse<Asset>>(`${apiUrl}/v1/assets/call/${id}`, options )
        
        return data;
    }

    async search(key:string){
        let options = {
            headers:this.headers,
            params: {
                key: encodeURI(key)
            }
        }
        const { data }   = await axios.get<DataArrayResponse<Asset>>(`${apiUrl}/v1/assets/search`,options )
        return data;
    }

    async create(asset: Asset){
        if(!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken
        let options = {
            headers:this.headers,
        }
        const { data }   = await axios.post<PageResponse>(`${apiUrl}/v1/assets/call`,JSON.stringify(asset),options )
        return data;
    }

    async update(asset: Asset){
        if(!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken
        let options = {
            headers: this.headers
        }
        const { data }  = await axios.put<PageResponse>(`${apiUrl}/v1/assets/call`,JSON.stringify(asset),options )
        return data;
    }

    async updateStatus(asset: Asset){
        if(!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken
        let options = {
            headers: this.headers
        }
        const { data }  = await axios.put<PageResponse>(`${apiUrl}/v1/assets/status`,JSON.stringify(asset),options )
        return data;
    }

    async delete(id: number,updateBy: string){
        if(!this.token) return null
        
        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken
        let options = {
            headers:this.headers
        }
        let deleteData:DeleteData = {
            id:id,
            updateBy:updateBy
        }
        const { data }  = await axios.post<PageResponse>(`${apiUrl}/v1/assets/delete`,JSON.stringify(deleteData),options )
        return data;
    }

}